import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-sm-flex align-items-center" };
const _hoisted_4 = { class: "d-flex align-items-center" };
const _hoisted_5 = ["placeholder"];
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_7 = { class: "table-responsive" };
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_9 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
};
const _hoisted_10 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_11 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_12 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_13 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_14 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_15 = { key: 0 };
const _hoisted_16 = {
    colspan: "8",
    class: "text-center py-4"
};
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0 text-capitalize" };
const _hoisted_18 = { class: "d-flex align-items-center text-capitalize" };
const _hoisted_19 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" };
const _hoisted_20 = ["onClick"];
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0 text-capitalize" };
const _hoisted_23 = { class: "d-flex align-items-center text-capitalize" };
const _hoisted_24 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" };
const _hoisted_25 = ["src"];
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_27 = { class: "form-check form-switch" };
const _hoisted_28 = ["checked", "onChange"];
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" };
const _hoisted_30 = { class: "dropdown" };
const _hoisted_31 = { class: "dropdown-menu" };
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = { key: 2 };
const _hoisted_36 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" };
const _hoisted_37 = { class: "mb-0 text-paragraph" };
const _hoisted_38 = { class: "mt-15 mt-md-0" };
const _hoisted_39 = { class: "pagination mb-0" };
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
    class: "modal fade",
    id: "contentModalScrollable_supplementTypes",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_42 = { class: "modal-dialog modal-dialog-scrollable modal-lg" };
const _hoisted_43 = { class: "modal-content flex-column justify-content-center" };
const _hoisted_44 = { class: "modal-header" };
const _hoisted_45 = { class: "modal-title fs-5" };
const _hoisted_46 = { class: "modal-body" };
const _hoisted_47 = {
    key: 0,
    class: "text-center py-4"
};
const _hoisted_48 = {
    key: 1,
    class: "text-center py-4"
};
const _hoisted_49 = { class: "text-muted" };
const _hoisted_50 = { key: 2 };
const _hoisted_51 = { class: "table-responsive" };
const _hoisted_52 = { class: "table align-middle mb-0" };
const _hoisted_53 = { class: "bg-success text-white" };
const _hoisted_54 = { class: "text-uppercase fw-medium shadow-none text-white fs-13 pt-0" };
const _hoisted_55 = { class: "text-uppercase fw-medium shadow-none text-white fs-13 pt-0" };
const _hoisted_56 = { class: "text-uppercase fw-medium shadow-none text-white fs-13 pt-0 text-end" };
const _hoisted_57 = { class: "fw-semibold text-black" };
const _hoisted_58 = ["onUpdate:modelValue"];
const _hoisted_59 = { class: "text-end" };
const _hoisted_60 = ["onClick", "disabled"];
const _hoisted_61 = { class: "modal-footer" };
const _hoisted_62 = {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
};
const _hoisted_63 = {
    class: "modal fade",
    id: "confirmModal",
    tabindex: "-1",
    "aria-labelledby": "confirmModalLabel",
    "aria-hidden": "true"
};
const _hoisted_64 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_65 = { class: "modal-content" };
const _hoisted_66 = { class: "modal-header" };
const _hoisted_67 = {
    class: "modal-title",
    id: "confirmModalLabel"
};
const _hoisted_68 = { class: "modal-body text-center" };
const _hoisted_69 = ["innerHTML"];
const _hoisted_70 = { class: "modal-footer" };
const _hoisted_71 = {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_EmptyTable = _resolveComponent("EmptyTable");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.gotoCreate && _ctx.gotoCreate(...args))),
                        class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                        type: "button"
                    }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('supplement.addSupplement')) + " ", 1),
                        _cache[8] || (_cache[8] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                    ]),
                    _createElementVNode("button", {
                        type: "button",
                        class: "default-outline-btn position-relative transition fw-medium text-black pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#contentModalScrollable_supplementTypes",
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.loadSupplementTypes && _ctx.loadSupplementTypes(...args)))
                    }, [
                        _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-cog position-relative ms-5 fs-12" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('supplement.manageTypes')), 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("form", {
                        class: "search-box position-relative me-15",
                        onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["prevent"]))
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.searchQuery) = $event)),
                            type: "text",
                            class: "form-control shadow-none text-black rounded-0 border-0",
                            placeholder: _ctx.$t('forms.searchSupplementPlaceholder'),
                            onInput: _cache[3] || (_cache[3] = ($event) => (_ctx.currentPage = 1))
                        }, null, 40, _hoisted_5), [
                            [_vModelText, _ctx.searchQuery]
                        ]),
                        _cache[10] || (_cache[10] = _createElementVNode("button", {
                            type: "submit",
                            class: "bg-transparent text-primary transition p-0 border-0"
                        }, [
                            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                        ], -1))
                    ], 32)
                ])
            ]),
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('lists.id')), 1),
                                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('lists.name')), 1),
                                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('lists.icon')), 1),
                                _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('lists.type')), 1),
                                _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('lists.availability')), 1),
                                _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('lists.extraPrice')), 1),
                                _cache[11] || (_cache[11] = _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                                }, null, -1))
                            ])
                        ]),
                        _createElementVNode("tbody", null, [
                            (_ctx.isLoading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                                    _createElementVNode("td", _hoisted_16, [
                                        _createVNode(_component_LoaderComponent)
                                    ])
                                ]))
                                : (!_ctx.isLoading && _ctx.allSupplement.length > 0)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.allSupplement, (supplement, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: supplement.id
                                        }, [
                                            _createElementVNode("th", _hoisted_17, [
                                                _createElementVNode("div", _hoisted_18, [
                                                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "form-check mb-0 text-capitalize" }, [
                                                        _createElementVNode("input", {
                                                            class: "form-check-input shadow-none",
                                                            type: "checkbox"
                                                        })
                                                    ], -1)),
                                                    _createElementVNode("div", _hoisted_19, [
                                                        _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: ($event) => (_ctx.selectForDetail(supplement))
                                                        }, _toDisplayString(index + 1) + " - " + _toDisplayString(_ctx.getShortUuid(supplement.id)), 9, _hoisted_20)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_21, _toDisplayString(supplement.name), 1),
                                            _createElementVNode("th", _hoisted_22, [
                                                _createElementVNode("div", _hoisted_23, [
                                                    _createElementVNode("div", _hoisted_24, [
                                                        _createElementVNode("img", {
                                                            src: _ctx.getSupplementImage(supplement),
                                                            class: "rounded-circle me-8",
                                                            width: "24",
                                                            height: "24",
                                                            alt: "supplement"
                                                        }, null, 8, _hoisted_25)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("td", null, _toDisplayString(supplement.supplementTypeLabel ?? '-'), 1),
                                            _createElementVNode("td", _hoisted_26, [
                                                _createElementVNode("div", _hoisted_27, [
                                                    _createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "checkbox",
                                                        checked: _ctx.getSupplementAvailability(supplement),
                                                        onChange: ($event) => (_ctx.toggleSupplementActivation(supplement, $event))
                                                    }, null, 40, _hoisted_28)
                                                ])
                                            ]),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.formatExtraCostPrice(supplement)), 1),
                                            _createElementVNode("td", _hoisted_29, [
                                                _createElementVNode("div", _hoisted_30, [
                                                    _cache[16] || (_cache[16] = _createElementVNode("button", {
                                                        class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                                        type: "button",
                                                        "data-bs-toggle": "dropdown",
                                                        "aria-expanded": "false"
                                                    }, [
                                                        _createElementVNode("i", { class: "flaticon-dots" })
                                                    ], -1)),
                                                    _createElementVNode("ul", _hoisted_31, [
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.selectForDetail(supplement))
                                                            }, [
                                                                _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.view')), 1)
                                                            ], 8, _hoisted_32)
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.selectForDetail(supplement))
                                                            }, [
                                                                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.edit')), 1)
                                                            ], 8, _hoisted_33)
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                "data-bs-toggle": "modal",
                                                                "data-bs-target": "#confirmModal",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.selectForDelete(supplement))
                                                            }, [
                                                                _cache[15] || (_cache[15] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.delete')), 1)
                                                            ], 8, _hoisted_34)
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ]));
                                    }), 128))
                                    : (_openBlock(), _createElementBlock("tr", _hoisted_35, [
                                        _createVNode(_component_EmptyTable, {
                                            message: _ctx.$t('supplement.noSupplements'),
                                            colspan: 8,
                                            textClass: "text-muted"
                                        }, null, 8, ["message"])
                                    ]))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.paginationInfo), 1),
                    _createElementVNode("nav", _hoisted_38, [
                        _createElementVNode("ul", _hoisted_39, [
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Previous",
                                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
                                }, [...(_cache[17] || (_cache[17] = [
                                        _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                    ]))])
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generatePageNumbers(), (page) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: page,
                                    class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
                                }, [
                                    _createElementVNode("a", {
                                        class: "page-link",
                                        href: "#",
                                        onClick: _withModifiers(($event) => (_ctx.changePage(page)), ["prevent"])
                                    }, _toDisplayString(page), 9, _hoisted_40)
                                ], 2));
                            }), 128)),
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Next",
                                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
                                }, [...(_cache[18] || (_cache[18] = [
                                        _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                    ]))])
                            ], 2)
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("h1", _hoisted_45, _toDisplayString(_ctx.$t('supplement.manageTypePositions')), 1),
                        _cache[19] || (_cache[19] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                        (_ctx.isLoadingTypes)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                _createVNode(_component_LoaderComponent)
                            ]))
                            : (_ctx.supplementTypes.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t('supplement.noTypesAvailable')), 1)
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, [
                                        _createElementVNode("table", _hoisted_52, [
                                            _createElementVNode("thead", _hoisted_53, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("th", _hoisted_54, _toDisplayString(_ctx.$t('supplement.type')), 1),
                                                    _createElementVNode("th", _hoisted_55, _toDisplayString(_ctx.$t('supplement.position')), 1),
                                                    _createElementVNode("th", _hoisted_56, _toDisplayString(_ctx.$t('common.actions')), 1)
                                                ])
                                            ]),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedSupplementTypes, (type) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                        key: type.code || type.type
                                                    }, [
                                                        _createElementVNode("td", _hoisted_57, _toDisplayString(type.label || type.code || type.type || type), 1),
                                                        _createElementVNode("td", null, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "number",
                                                                class: "form-control shadow-none rounded-0 text-black",
                                                                "onUpdate:modelValue": ($event) => ((type.position) = $event),
                                                                min: "1",
                                                                style: { "width": "100px" }
                                                            }, null, 8, _hoisted_58), [
                                                                [
                                                                    _vModelText,
                                                                    type.position,
                                                                    void 0,
                                                                    { number: true }
                                                                ]
                                                            ])
                                                        ]),
                                                        _createElementVNode("td", _hoisted_59, [
                                                            _createElementVNode("button", {
                                                                onClick: ($event) => (_ctx.updateTypePosition(type)),
                                                                class: "btn btn-sm btn-primary",
                                                                type: "button",
                                                                disabled: _ctx.isUpdatingPosition
                                                            }, [
                                                                _cache[20] || (_cache[20] = _createElementVNode("i", { class: "fas fa-save me-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.save')), 1)
                                                            ], 8, _hoisted_60)
                                                        ])
                                                    ]));
                                                }), 128))
                                            ])
                                        ])
                                    ])
                                ]))
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("button", _hoisted_62, _toDisplayString(_ctx.$t('common.close')), 1)
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("h5", _hoisted_67, _toDisplayString(_ctx.$t('supplement.deleteConfirmation')), 1),
                        _cache[21] || (_cache[21] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                        _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fas fa-exclamation-triangle warning-icon" }, null, -1)),
                        _createElementVNode("p", {
                            class: "mb-0",
                            innerHTML: _ctx.$t('supplement.deleteConfirmationText')
                        }, null, 8, _hoisted_69)
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("button", _hoisted_71, [
                            _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fas fa-times me-2" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger",
                            onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.confirmationDeleteAction(_ctx.supplementSelected))),
                            "data-bs-dismiss": "modal"
                        }, [
                            _cache[24] || (_cache[24] = _createElementVNode("i", { class: "fas fa-trash-alt me-2" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                        ])
                    ])
                ])
            ])
        ])
    ], 64));
}
